<template>
  <li class="dropdownItem dropdownItem__reservation">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      預約資料
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/ReservationList'"
          v-if="permissionReservation"
        >
          預約單
        </router-link>
      </li>
    </ul>
  </li>
</template>
<script>
export default {
  props: ['permissionReservation'],
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownReservation.vue